export function calculateNodeIndent(level: number): number {
  return 24 * (level - 1);
}
